/**
 * DEV-49100 — pre-authenticated deep link into the AppSheet warehouse
 * ordering portal (`stock_order_backend`, `Catalogue` view).
 *
 * Used from the engineer app as a low-emphasis fallback route for parts
 * our trade suppliers don't stock. When the new WMS ships, the warehouse
 * will be modelled as a proper supplier and this link goes away.
 */
export const WAREHOUSE_PORTAL_URL =
  'https://www.appsheet.com/start/f5197ef8-574e-4491-8c8b-4b6fbb2450e9?platform=desktop#appName=stock_order_backend-872591089&vss=H4sIAAAAAAAAA6WOsQ4CIRBE_2VqvoDWWBijjcZGLNZjzxA5uAinXgj_Lpi7WKvlzOa9nYS74ccuUnOFPKZPWvMIiaSwH3tWkAoL7-LNWwWhsKVuKimS9ZehpIx8ErMgcoBMX_Lyz_8CRrOLpjV8q7KKFskElnPFajFDyALdEOls-b25QDmXrvXNEFgfyphfRoSVWz57cnrjdXG2ZAPnFye_CmZqAQAA&view=Catalogue'
